<template>
  <el-dialog custom-class="max-dialog1256" :title="title" :visible.sync="dialogFormVisible" center :append-to-body="true"
             :close-on-click-modal="false">
    <el-form :model="form" ref="form1" :rules="rules" style="text-align: center">
      <el-row :gutter="20">
        <el-col :span="15">
          <el-form-item :label="form.accountname=='销售支持'?'品牌':'摘要'" :label-width="formLabelWidth" prop="summary">
            <el-input v-model="form.summary" auto-complete="off" clearable :required="true"
                      @click.native="selectCategory" @clear="clearCategory" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9" v-if="parames.length>0">
          <el-form-item label="账套" :label-width="formLabelWidth" prop="hetongserial" style="text-align: left;">
            <el-radio-group v-model="form.hetongserial" v-for="(item) in parames" :key="item.value">
              <el-radio :label="item.value" :key="item.value" style="padding-right: 25px">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-form-item label="客户" :label-width="formLabelWidth" prop="customername" style="text-align: left;">
            <span v-if="simpleedit || writeoffOrders.length > 0">{{form.customername}}</span>
            <AutoCustomer @clear="clearCustomerName" v-else :content="form.customername" :size="''" :splitByAddress="false"
                          @handleSelect="selectExternalDept"></AutoCustomer>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="客户编号" :label-width="formLabelWidth" prop="customername" style="text-align: left;">
            {{form.customerserial}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="日期" :label-width="formLabelWidth" prop="accdate" style="text-align: left;">
            <el-date-picker
              v-model="form.accdate" v-if="!simpleedit"
              type="date" :clearable="false"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <el-radio-group v-model="form.accdate" v-else>
              <el-radio v-for="item in dateArea" :label="item" :key="item">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!--<el-col :span="8" v-if="!simpleedit">-->
          <!--<el-form-item label="" :label-width="formLabelWidth" style="text-align: left;">-->
            <!--冲  <el-date-picker v-model="form.substitute" :clearable="false"-->
                               <!--type="month" :value-format="'yyyy-MM'" style="width:120px;"-->
                               <!--placeholder="选择年月"></el-date-picker> 月账-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="8" v-if="title == '收款'&&!simpleedit">
          <el-form-item label="" :label-width="formLabelWidth" prop="beihuoreceive" style="text-align: left;">
            <el-checkbox v-model="beihuoreceive">预收铺货款</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="金额" :label-width="formLabelWidth" prop="credit" style="text-align: left;">
            <el-input-number v-model="form.credit" style="width:220px;" :controls="false" :disabled="writeoffOrders.length > 0"></el-input-number>
            <span v-if="writeoffOrders.length > 0" style="color: #909399; font-size: 12px; margin-left: 5px;">（关联核销，不可修改）</span>
          </el-form-item>
        </el-col>
        <el-col :span="10" v-if="title == '收款'">
          <el-form-item label="收款银行" :label-width="formLabelWidth" prop="auxiliaryserial" style="text-align: left;" >
            <el-select v-model="form.buyhetongserial" placeholder="请选择" clearable filterable>
              <el-option
                v-for="item in buyhetongseriallist"
                :key="item.value"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="!simpleedit">
        <el-col :span="10">
          <el-form-item label="凭证号" :label-width="formLabelWidth" prop="auxiliaryserial" style="text-align: left;">
            <el-input v-model="form.auxiliaryserial" style="width:220px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="回款方式" :label-width="formLabelWidth" prop="auxiliary" style="text-align: left;">
            <el-input v-model="form.auxiliary" style="width:220px;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="!simpleedit && title === '收款'">
        <el-col :span="10">
          <el-form-item label="汇款公司" :label-width="formLabelWidth" prop="buyhetongname" style="text-align: left;">
            <el-input v-model="form.buyhetongname" style="width:220px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="税号" :label-width="formLabelWidth" prop="billserial" style="text-align: left;">
            <el-input v-model="form.billserial" style="width:220px;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark" treeContent>
            <el-input
              type="textarea"
              :rows="3"
              :maxlength="450"
              placeholder="请输入内容（最多450字）"
              v-model="form.remark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 核销订单列表 -->
    <el-row v-if="(writeoffOrders.length > 0 || writeoffTotal > 0) && !simpleedit" :gutter="20">
      <el-col :span="24">
        <div style="margin-top: 10px;">
          <span style="font-size: 13px; font-weight: bold; color: #606266;">核销订单</span>
          <div style="margin: 8px 0; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
            <el-input v-model="writeoffSearch.erpserial" size="mini" placeholder="订单号" clearable style="width: 140px;" @keyup.enter.native="searchWriteoffOrders"></el-input>
            <el-input v-model="writeoffSearch.tracknum" size="mini" placeholder="跟踪号" clearable style="width: 140px;" @keyup.enter.native="searchWriteoffOrders"></el-input>
            <el-button type="primary" size="mini" @click="searchWriteoffOrders">搜索</el-button>
          </div>
          <el-table :data="writeoffOrders" border size="mini" style="width: 100%;" :height="writeoffTableHeight">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="erpserial" label="订单号" width="130" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="viewWriteoffOrder(scope.row)">{{scope.row.erpserial}}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="tracknum" label="跟踪号" width="160" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="handleoverdate" label="发货时间" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="订单总额" width="110" align="right">
              <template slot-scope="scope">{{scope.row.htje | formatMoney}}</template>
            </el-table-column>
            <el-table-column label="运费" width="100" align="right">
              <template slot-scope="scope">{{scope.row.expressfee | formatMoney}}</template>
            </el-table-column>
            <el-table-column label="本次核销" width="110" align="right">
              <template slot-scope="scope">{{scope.row.writeoffamount | formatMoney}}</template>
            </el-table-column>
            <el-table-column label="状态" width="80" align="center">
              <template slot-scope="scope">{{scope.row.isfullwriteoff == 1 ? '已核清' : '部分核销'}}</template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleWriteoffSizeChange"
            @current-change="handleWriteoffPageChange"
            :current-page="writeoffPage"
            :page-sizes="[20, 50, 100]"
            :page-size="writeoffPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="writeoffTotal"
            style="margin-top: 8px; text-align: right;">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-collapse v-model="activeNames" v-if="!form.unitguid">
      <el-collapse-item name="1">
        <template slot="title" style="display: inline-block;">
        <span class="titlecolor">历史记录
        </span>
        </template>
        <DetailList ref="DetailList" :accountnames="form.accountname" :simpleedit="simpleedit"></DetailList>
      </el-collapse-item>
    </el-collapse>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="success" @click="showImportDialog" v-if="canEdit&&title=='收款'&&!form.unitguid">批量导入</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="canEdit">保 存</el-button>
      <el-button type="danger" @click="deleteData" :loading="loading" v-if="form.unitguid&&canEdit">删 除</el-button>
    </div>
    <JxcgoodscategorySel ref="JxcgoodscategorySel"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>

    <!-- 批量导入确认弹窗 -->
    <el-dialog title="批量导入确认" :visible.sync="importDialogVisible" width="85%" center :append-to-body="true"
               :close-on-click-modal="false" top="5vh">
      <div style="margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="selectExcelFile">选择Excel文件</el-button>
        <input type="file" ref="importFileInput" accept=".xls,.xlsx" style="display:none" @change="onExcelFileChange"/>
        <span v-if="importFileName" style="margin-left:10px;color:#606266">已选择: {{importFileName}}</span>
      </div>
      <el-table :data="importPreviewData" border size="mini" max-height="400"
                :row-class-name="importRowClassName"
                style="width:100%">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="accdate" label="日期" width="110" align="center">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.accdate}">{{scope.row.accdate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" width="120">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.summary}">{{scope.row.summary}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="hetongserialName" label="账套" width="80" align="center">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.hetongserial}">{{scope.row.hetongserialName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerserial" label="客户编码" width="100">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.customerserial}">{{scope.row.customerserial}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customername" label="客户名称" width="140">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.customername}">{{scope.row.customername}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="credit" label="金额" width="90" align="right">
          <template slot-scope="scope">
            <span :class="{'import-error': scope.row._errors.credit}">{{scope.row.credit}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auxiliaryserial" label="凭证号" width="90"></el-table-column>
        <el-table-column prop="buyhetongserial" label="收款银行" width="100"></el-table-column>
        <el-table-column prop="auxiliary" label="回款方式" width="90"></el-table-column>
        <el-table-column prop="_status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row._status=='success'" style="color:#67C23A">已导入</span>
            <span v-else-if="scope.row._status=='fail'" style="color:#F56C6C">{{scope.row._failMsg}}</span>
            <span v-else-if="scope.row._hasError" style="color:#F56C6C">异常</span>
            <span v-else style="color:#909399">待导入</span>
          </template>
        </el-table-column>
        <el-table-column prop="_errorMsg" label="异常原因" min-width="120">
          <template slot-scope="scope">
            <span style="color:#F56C6C">{{scope.row._errorMsg}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;color:#909399">
        共 {{importPreviewData.length}} 条，异常 {{importErrorCount}} 条，已导入 {{importSuccessCount}} 条
      </div>
      <div slot="footer">
        <el-button @click="importDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="doBatchImport" :loading="importLoading"
                   :disabled="importErrorCount>0||importPreviewData.length==0||importSuccessCount==importPreviewData.length">开始导入</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>
  import JxcgoodscategorySel from '@/components/set/jxcgoodscategory/JxcgoodscategorySel'
  import DetailList from './DetailList'
  import {saveData, getDetail,deleteData} from '@/api/voucher/accountvoucherdetail'
  import {getBySerial} from '@/api/set/externaldept'
  import {getListData} from '@/api/set/PriceandKd';
  import {JieZhangDate} from '@/api/voucher/accountresultbz';
  import {getpinyinlistData as getCustomerList} from '@/api/set/externaldept';
  import {listWriteoffByVoucher} from '@/api/voucher/accountwriteoff'
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit'
  export default {
    name: "ReceivablesEdit",
    data() {

      return {
        title: '收款',
        needclose:false,
        dialogFormVisible: false,
        activeNames: ['1'],
        loading: false,
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        canEdit:true,
        beihuoreceive:false,
        parames:[],
        setofbooks:'',
        dateform: {
          jzYear: 2019,
          jzMonth: 4,
          hasjieZhang: true,
          commonjiezhangdate: 25,
          closeaccountsdate:25,
        },
        form: {  //表单数据
          unitguid: "",
          summary: '',//摘要，如果是销售支持，就存品牌名称
          customerserial: '',//客户编码
          customername: '',//客户名称c
          accdate: "",//到账日期
          debit: '',//借方
          credit: '',//贷方
          remark: '',//备注
          substitute:'',
          accountname: '',//科目名称
          yearflag: '',
          monthflag: '',
          applybydserial: "",
          applybydname: "",
          independentserial: "",
          accvoucherguid: "",
          auxiliaryserial: '',//凭证号
          auxiliary: '',//回款方式
          buyhetongname: '',//汇款公司名称
          billserial: '',//税号
          billtype: '',//品牌编号
          buyhetongserial: '',//收款银行
          hasstore:0,//是否是备货预收款
          hetongserial:'',//账套
        },
        dateArea:[],
        buyhetongseriallist: [],//收款银行选择项
        //核销订单相关
        writeoffOrders: [],
        writeoffTableHeight: 140,
        writeoffPage: 1,
        writeoffPageSize: 20,
        writeoffTotal: 0,
        writeoffSearch: {
          erpserial: '',
          tracknum: '',
          logisticstracknum: ''
        },
        //批量导入相关
        importDialogVisible: false,
        importFileName: '',
        importPreviewData: [],
        importLoading: false,
        importCustomerCache: {},//客户缓存 {customerserial: {dname, servedserial, ...}}
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          customername: [
            {required: true, message: '请选择客户', trigger: 'change'},
          ],
          accdate: [
            {required: true, message: '请选择日期', trigger: 'blur'},
          ],
          remark: [
            {max: 450, message: '备注最多450个字符', trigger: 'blur'},
          ],
        },
      }
    },
    props:{
      simpleedit:false,
    },
    computed: {
      importErrorCount() {
        return this.importPreviewData.filter(r => r._hasError).length;
      },
      importSuccessCount() {
        return this.importPreviewData.filter(r => r._status === 'success').length;
      }
    },
    methods: {
      //收款银行
      buyhetongserial() {
        this.buyhetongseriallist = [];
        getListData({
            offset: 0,
            limit: 10000,
            paraname: '收款银行',
          }
        ).then(response => {
          var tabledata = response.data.obj

          for (let i = 0; i < tabledata.length; i++) {
            var obj = {name: '', value: ''}
            obj.name = tabledata[i].name
            obj.value = tabledata[i].unitguid
            this.buyhetongseriallist.push(obj)
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      //清空商品类别
      clearCategory() {
        this.form.billtype = ''
        this.form.summary = ''
        this.canshowgoodsel = false
      },
      selectCategory() {
        if (this.form.accountname == '销售支持') {
          if (this.canshowgoodsel) {
            this.$refs.JxcgoodscategorySel.show()
          } else {
            this.canshowgoodsel = true
          }
        }
      },
      //选择商品类别之后执行
      afterSelectCategoryCode(row) {
        this.form.billtype = row.categorycode
        this.form.summary = row.categoryname
      },
      getBeginDate() {//获取允许添加的 日期
        var date = new Date(this.dateform.jzYear + '-' + this.dateform.jzMonth + '-' + this.dateform.closeaccountsdate);
        if (this.dateform.closeaccountsdate == 1) {
          //结账日是1号，则当月全部锁定，跳到下个月1号
          date.setMonth(date.getMonth() + 1);
          date.setDate(1);
        } else {
          date.setDate(date.getDate() + 1);
        }
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return date.getFullYear() + '-' + month + '-' + day;
      },
      deleteData() {
        if (this.form.unitguid) {
          if (new Date(this.form.accdate) < new Date(this.getBeginDate())) {
            this.$message({
              type: 'error',
              duration: 1500,
              message: '已结账的数据不能删除！'
            })
            return
          }
          this.$confirm("是否确定删除？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteData({unitguid: this.form.unitguid, accvoucherguid: this.form.accvoucherguid}).then(response => {
              this.dialogFormVisible = false;
              //this.$emit("bindgrid")
              this.$emit("reflash")
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              duration: 1500,
              message: '已取消'
            });
          });
        }
      },
      saveData() {
        if (this.parames.length > 0 && !this.form.hetongserial) {
          this.$message({
            type: 'error',
            duration: 1500,
            message: '账套必须选择！'
          })
          return
        }
        if (new Date(this.form.accdate) < new Date(this.getBeginDate())) {
          this.$message({
            type: 'error',
            duration: 1500,
            message: '选择的日期不能小于' + this.getBeginDate() + '！'
          })
          return
        }

        this.$refs.form1.validate((valid) => {
          if (valid) {
            if ((this.form.debit || 0) == 0 && (this.form.credit || 0) == 0) {
              this.$message({
                type: 'error',
                duration: 1500,
                message: '总金额不能为0！'
              })
              return
            }

            if (this.title == '收款') {
              this.form.accountname = this.beihuoreceive ? "预收铺货款" : "已收现销"
            } else {
              this.form.accountname = this.title
            }
            this.loading = true

            var seldate = ''
            if (this.form.substitute) {
              seldate = new Date(this.form.substitute)
            } else {
              seldate = new Date(this.form.accdate)
            }
            this.form.yearflag = seldate.getFullYear()
            this.form.monthflag = seldate.getMonth() + 1
            saveData(this.form).then((response) => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  duration: 1500,
                  message: '保存成功'
                })
                //this.$emit("bindgrid")
                this.buyhetongserial()//收款银行
                if (this.form.unitguid) {
                  this.dialogFormVisible = false;
                  this.$emit("reflash")
                } else {
                  this.initForm();
                  this.showDetailList();
                }
                if (this.needclose) {
                  this.dialogFormVisible = false;
                  // this.$emit("reflash")
                }
              } else {
                this.loading = false
                this.$message({
                  type: 'error',
                  duration: 1500,
                  message: response.data.msg
                })
              }
            })
          } else {
            this.loading = false
          }
        })
      },
      clearCustomerName() {
        this.form.customerserial = ""
        this.form.customername = ""
        this.form.applybydserial = ""
        this.form.applybydname = ""
        this.form.independentserial = ""
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserial = customerserial;
        this.form.customername = deptname;
        this.form.applybydserial = row.servedserial
        this.form.applybydname = row.servedname
        this.form.independentserial = row.servedserial
        this.dateform.closeaccountsdate = row.closeaccountsdate ? row.closeaccountsdate : this.dateform.commonjiezhangdate;

        // 手动触发客户字段验证，清除残留的"请选择客户"错误提示
        this.$nextTick(() => {
          if (this.$refs.form1) {
            this.$refs.form1.validateField('customername');
          }
        });

        this.showDetailList()
      },
      showDetailList() {
        if (!this.form.unitguid && this.$refs.DetailList) {
          if (this.title == '收款') {
            this.form.accountname = "已收现销"
          } else {
            this.form.accountname = this.title
          }
          this.$refs.DetailList.show(this.simpleedit ? '' : this.form.customerserial, this.form.accountname)
        }
      },
      show(title, arr) {
        this.needclose = false;
        JieZhangDate().then(response => {

          this.initForm();

          this.dateform.jzYear = parseInt(response.data.obj.split(';')[0]);
          this.dateform.jzMonth = parseInt(response.data.obj.split(';')[1]);
          this.dateform.commonjiezhangdate = parseInt(response.data.obj.split(';')[2]);
          this.dateform.closeaccountsdate = this.dateform.commonjiezhangdate;

          if (arr) {
            this.needclose = true;
            this.form.customername = arr.customername;
            this.form.customerserial = arr.customerserial;
            this.form.credit = arr.totalmoney.toFixed(2)
            var da = new Date();
            this.form.accdate = da.getFullYear() + '-' + (da.getMonth() + 1) + '-' + da.getDate();
          }
          if (title) {
            this.title = title
            if (title == '收款') {
              this.form.accountname = "已收现销"
              this.buyhetongserial();
            } else {
              this.form.accountname = title
            }
          }

          this.dialogFormVisible = true;
          this.$nextTick(() => {
            this.showDetailList();
          })
        })
      },
      initData(unitguid, title) {
        this.initForm()
        this.title = title
        if (this.title == '收款') {
          this.buyhetongserial();
        }
        this.dialogFormVisible = true;
        this.form.unitguid = unitguid
        this.canEdit = false;
        JieZhangDate().then(response => {
          this.dateform.jzYear = parseInt(response.data.obj.split(';')[0]);
          this.dateform.jzMonth = parseInt(response.data.obj.split(';')[1]);
          this.dateform.commonjiezhangdate = parseInt(response.data.obj.split(';')[2]);

          getDetail({unitguid: unitguid}).then(response => {

            for (let i in  this.form) {
              this.form[i] = response.data.obj[i];
            }
            if (this.form.yearflag) {
              this.form.substitute = this.form.yearflag + '-' + this.form.monthflag
            } else {
              this.form.substitute = this.form.accdate;
            }
            this.beihuoreceive = this.form.accountname == "预收铺货款";
            // 查询核销关联的订单列表
            if (this.form.accvoucherguid) {
              this.loadWriteoffOrders()
            }
            getBySerial({customerserial: this.form.customerserial}).then(response => {
              if (response.data.code == 0) {
                this.dateform.closeaccountsdate = response.data.obj.closeaccountsdate ? response.data.obj.closeaccountsdate : this.dateform.commonjiezhangdate;
                if (new Date(this.form.accdate) >= new Date(this.getBeginDate())) {
                  this.canEdit = true;
                }
              }
            })
          })

        });
      },
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        if (this.$refs.DetailList !== undefined) {
          this.$refs.DetailList.initform();
        }
        for (let i in this.form) {
          this.form[i] = "";
        }
        this.beihuoreceive = false;
        this.buyhetongseriallist = [];
        this.canshowgoodsel = true;
        this.writeoffOrders = []
        this.writeoffTotal = 0
        this.writeoffPage = 1
        this.loading = false;
      },
      // ========== 批量导入相关方法 ==========
      showImportDialog() {
        this.importDialogVisible = true;
        this.importFileName = '';
        this.importPreviewData = [];
        this.importLoading = false;
      },
      selectExcelFile() {
        this.$refs.importFileInput.value = ''; // 允许重复选择同一文件
        this.$refs.importFileInput.click();
      },
      onExcelFileChange(event) {
        var file = event.target.files[0];
        if (!file) return;
        var reg = /(\.xls|\.xlsx)$/;
        if (!reg.test(file.name)) {
          this.$message.error('只能导入.xls或者.xlsx的文件！');
          return;
        }
        this.importFileName = file.name;
        this.importPreviewData = []; // 清空上次数据
        this.$importExcel(file, (data) => {
          this.parseImportData(data);
        });
      },
      parseImportData(data) {
        // Excel列名映射：日期→accdate, 摘要→summary, 账套→hetongserialName, 金额→credit,
        // 客户编码→customerserial, 客户名称→customername, 凭证号→auxiliaryserial,
        // 收款银行→buyhetongserial, 回款方式→auxiliary
        var rows = data.map(item => {
          var row = {
            accdate: this.formatExcelDate(item['日期'] || ''),
            summary: item['摘要'] || '',
            hetongserialName: item['账套'] || '',
            hetongserial: '', // 提交时转换成代码
            credit: item['金额'] ? Number(item['金额']) : 0,
            customerserial: (item['客户编码'] || '').toString().trim(),
            customername: item['客户名称'] || '',
            auxiliaryserial: item['凭证号'] || '',
            buyhetongserial: item['收款银行'] || '', // 收款银行按Excel值直接导入
            auxiliary: item['回款方式'] || '',
            _errors: {},
            _hasError: false,
            _errorMsg: '',
            _status: '', // 'success'|'fail'|''
            _failMsg: ''
          };
          // 基本校验（不依赖客户信息的）
          if (!row.accdate) {
            row._errors.accdate = true;
            row._hasError = true;
            row._errorMsg += '日期为空;';
          }
          if (!row.credit) {
            row._errors.credit = true;
            row._hasError = true;
            row._errorMsg += '金额为空;';
          }
          if (!row.summary) {
            row._errors.summary = true;
            row._hasError = true;
            row._errorMsg += '摘要为空;';
          }
          // 账套：如果有可选项则必填，且转换成代码
          if (this.parames.length > 0) {
            if (!row.hetongserialName) {
              row._errors.hetongserial = true;
              row._hasError = true;
              row._errorMsg += '账套为空;';
            } else {
              var hetongItem = this.parames.find(p => p.name == row.hetongserialName);
              if (hetongItem) {
                row.hetongserial = hetongItem.value;
              } else {
                row._errors.hetongserial = true;
                row._hasError = true;
                row._errorMsg += '账套名称不匹配;';
              }
            }
          } else {
            row.hetongserialName = '';
          }
          return row;
        });
        this.importPreviewData = rows;
        // 异步校验客户信息
        this.validateCustomersAsync();
      },
      validateCustomersAsync() {
        // 收集所有不重复的客户编码
        var rows = this.importPreviewData;
        var serials = [];
        for (var i = 0; i < rows.length; i++) {
          var cs = rows[i].customerserial;
          if (cs && serials.indexOf(cs) === -1) {
            serials.push(cs);
          }
        }
        // 过滤出未缓存的客户编码，逐个调接口查询
        var self = this;
        var idx = 0;

        function queryNext() {
          if (idx >= serials.length) {
            // 所有查询完毕，更新每行数据
            self.updateRowCustomerInfo();
            return;
          }
          var cs = serials[idx];
          idx++;
          if (self.importCustomerCache[cs] !== undefined) {
            // 已缓存，跳过
            queryNext();
            return;
          }
          getCustomerList({
            customerserial: cs,
            unitgroup: 1,
            splitByAddress: '0'
          }).then(response => {
            if (response.data.code == 0) {
              var list = response.data.obj || [];
              var found = list.find(c => c.customerserial == cs);
              self.importCustomerCache[cs] = found || null;
            } else {
              self.importCustomerCache[cs] = null;
            }
            queryNext();
          }).catch(() => {
            self.importCustomerCache[cs] = null;
            queryNext();
          });
        }

        queryNext();
      },
      updateRowCustomerInfo() {
        var rows = this.importPreviewData;
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          if (!row.customerserial) {
            row._errors.customerserial = true;
            row._hasError = true;
            row._errorMsg += '客户编码为空;';
          } else {
            var found = this.importCustomerCache[row.customerserial];
            if (!found) {
              row._errors.customerserial = true;
              row._hasError = true;
              row._errorMsg += '客户编码不存在;';
            } else {
              row.customername = row.customername || found.dname;
              row.applybydserial = found.servedserial || '';
              row.applybydname = found.servedname || '';
              row.independentserial = found.servedserial || '';
              row.closeaccountsdate = found.closeaccountsdate || '';
            }
          }
          // 客户名称必填
          if (!row.customername) {
            row._errors.customername = true;
            row._hasError = true;
            row._errorMsg += '客户名称为空;';
          }
          // 结账日期判断
          if (row.accdate) {
            var caDate = row.closeaccountsdate || this.dateform.commonjiezhangdate;
            var jzBaseDate = new Date(this.dateform.jzYear + '-' + this.dateform.jzMonth + '-' + caDate);
            if (caDate == 1) {
              //结账日是1号，则当月全部锁定，跳到下个月1号
              jzBaseDate.setMonth(jzBaseDate.getMonth() + 1);
              jzBaseDate.setDate(1);
            } else {
              jzBaseDate.setDate(jzBaseDate.getDate() + 1);
            }
            var jzBeginDate = jzBaseDate.getFullYear() + '-' + (jzBaseDate.getMonth() + 1) + '-' + jzBaseDate.getDate();
            if (new Date(row.accdate) < new Date(jzBeginDate)) {
              row._errors.accdate = true;
              row._hasError = true;
              row._errorMsg += '日期已结账（最小允许日期为' + jzBeginDate + '）;';
            }
          }
        }
        // 触发视图更新
        this.importPreviewData = JSON.parse(JSON.stringify(this.importPreviewData));
      },
      formatExcelDate(val) {
        // Excel日期可能是数字(如44927)、Date对象、字符串
        if (!val) return '';
        var d;
        if (val instanceof Date) {
          // xlsx把日期列解析成了Date对象
          d = val;
        } else if (typeof val === 'number') {
          // Excel日期数字转实际日期（从1900-01-01起算，有1900bug偏移1天）
          d = new Date(1899, 11, 30);
          d.setDate(d.getDate() + val);
        } else {
          // 字符串：将 / 替换为 -，再尝试解析
          var str = val.toString().trim().replace(/\//g, '-');
          d = new Date(str);
          // 如果解析失败就直接返回原字符串
          if (isNaN(d.getTime())) return str;
        }
        var y = d.getFullYear();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
      },
      importRowClassName({row}) {
        if (row._status === 'success') return 'import-success-row';
        if (row._hasError || row._status === 'fail') return 'import-error-row';
        return '';
      },
      doBatchImport() {
        // 有异常数据则不允许保存
        if (this.importErrorCount > 0) {
          this.$message.error('存在异常数据，请修正后再导入！');
          return;
        }
        this.importLoading = true;
        var pendingRows = this.importPreviewData.filter(r => !r._status);
        var idx = 0;
        var self = this;

        function importNext() {
          if (idx >= pendingRows.length) {
            self.importLoading = false;
            self.$message.success('导入完成！成功 ' + self.importSuccessCount + ' 条');
            self.showDetailList(); // 刷新历史记录
            return;
          }
          var row = pendingRows[idx];
          idx++;
          // 构造与saveData相同的form对象
          var formData = {
            summary: row.summary,
            customerserial: row.customerserial,
            customername: row.customername,
            accdate: row.accdate,
            credit: row.credit,
            accountname: '已收现销',
            auxiliaryserial: row.auxiliaryserial,
            auxiliary: row.auxiliary,
            buyhetongserial: row.buyhetongserial,
            hetongserial: row.hetongserial,
            buyhetongname: row.buyhetongname || '',
            billserial: row.billserial || '',
            applybydserial: row.applybydserial || '',
            applybydname: row.applybydname || '',
            independentserial: row.independentserial || '',
            hasstore: 0
          };
          // 设置年月标识
          var seldate = new Date(formData.accdate);
          formData.yearflag = seldate.getFullYear();
          formData.monthflag = seldate.getMonth() + 1;

          saveData(formData).then(response => {
            if (response.data.code == 0) {
              row._status = 'success';
            } else {
              row._status = 'fail';
              row._failMsg = response.data.msg || '保存失败';
            }
            importNext();
          }).catch(() => {
            row._status = 'fail';
            row._failMsg = '网络异常';
            importNext();
          });
        }

        importNext();
      },
      loadWriteoffOrders() {
        var ths = this
        var params = {
          accvoucherguid: this.form.accvoucherguid,
          offset: (this.writeoffPage - 1) * this.writeoffPageSize,
          limit: this.writeoffPageSize,
          erpserial: this.writeoffSearch.erpserial || '',
          tracknum: this.writeoffSearch.tracknum || '',
          logisticstracknum: this.writeoffSearch.logisticstracknum || ''
        }
        listWriteoffByVoucher(params).then(res => {
          if (res.data.code === 0) {
            var pageData = res.data.obj || {}
            ths.writeoffOrders = pageData.rows || []
            ths.writeoffTotal = pageData.total || 0
            ths.$nextTick(() => {
              ths.writeoffTableHeight = ths.dialogtableHeight(410)
            })
          }
        })
      },
      searchWriteoffOrders() {
        this.writeoffPage = 1
        this.loadWriteoffOrders()
      },
      handleWriteoffSizeChange(val) {
        this.writeoffPageSize = val
        this.writeoffPage = 1
        this.loadWriteoffOrders()
      },
      handleWriteoffPageChange(val) {
        this.writeoffPage = val
        this.loadWriteoffOrders()
      },
      viewWriteoffOrder(row) {
        if (!row.erpserial) return
        this.$refs.DataContactEdit.initData(row)
        this.$refs.DataContactEdit.show()
      }
    },
    mounted() {
      var param = JSON.parse(localStorage.getItem("hpapi_userInfoModel")).setofbooks;
      if (param) {
        this.parames = JSON.parse(param);
      }else
        this.parames=[];
      var da = new Date();
      this.dateArea.push(da.getFullYear() + '-' + (da.getMonth() + 1) + '-' + da.getDate());
      var time = da.getTime() - 24 * 60 * 60 * 1000;
      da = new Date(time); // 获取的是前一天日期
      this.dateArea.push(da.getFullYear() + '-' + (da.getMonth() + 1) + '-' + da.getDate());
    },
    filters: {
      formatMoney(val) {
        if (val === null || val === undefined || val === '') return '0.00'
        var num = parseFloat(val)
        if (isNaN(num)) return '0.00'
        return num.toFixed(2)
      }
    },
    components: {
      DetailList,
      JxcgoodscategorySel,
      CstagreementEdit
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
  .import-error {
    color: #F56C6C;
    font-weight: bold;
  }
</style>
<style>
  .import-error-row {
    background-color: #fef0f0 !important;
  }
  .import-success-row {
    background-color: #f0f9eb !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/voucher/ReceivablesEdit.vue